module.exports = __webpack_public_path__ + "img/winery_afternoon_tea2.0ebfc568.png";